export default "__VITE_ASSET__b4afef70__"